<template>
  <v-card id="appliance-rule-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.ApplianceRuleCreate')"
          @click="add"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="rules"
      :loading="loading"
      no-data-text="Правил пока нет"
      hide-default-footer
      disable-pagination
    >
      <template #[`item.isEnabled`]="{ item }">
        <v-icon
          v-if="item.isEnabled"
          size="20"
          color="success"
        >
          {{ icons.mdiCheck }}
        </v-icon>
      </template>
      <template #[`item.dishName`]="{ item }">
        <span v-if="item.dishName">{{ item.dishName }}</span>
        <span
          v-else
          class="warning--text"
        >не выбран</span>
        <v-tooltip
          v-if="item.dishName && !item.isDishAvailable"
          bottom
        >
          <template #activator="{ on, attrs }">
            <v-icon
              size="18"
              color="warning"
              class="ms-1"
              v-bind="attrs"
              v-on="on"
            >
              {{ icons.mdiAlertOutline }}
            </v-icon>
          </template>
          <span>Позиции нет в Delivery или она платная — правило молчит</span>
        </v-tooltip>
      </template>
      <template #[`item.categories`]="{ item }">
        {{ item.categories.length ? item.categories.join(', ') : 'любой заказ' }}
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-center">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.ApplianceRuleUpdate')"
                v-bind="attrs"
                v-on="on"
                @click="edit(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.ApplianceRuleDelete')"
                v-bind="attrs"
                v-on="on"
                @click="deletePopupShow(item.id, item.dishName)"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <appliance-rule-form
      :show="formShown"
      :label="formLabel"
      :save="saveRule"
      :cancellation="closeForm"
    />

    <delete-dialog
      ref="deletePopup"
      :label="deleteLabel"
      @delete-confirmed="removeRule"
    />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiCheck,
  mdiAlertOutline,
} from '@mdi/js'
import DeleteDialog from '@/components/delete-dialog'
import ApplianceRuleForm from '@/views/appliance-rule/appliance-rule-form.vue'
import { hasPermission } from '@/helpers/index'

export default {
  name: 'ApplianceRuleList',
  components: { DeleteDialog, ApplianceRuleForm },
  data: () => ({
    icons: {
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiCheck,
      mdiAlertOutline,
    },
    deleteLabel: '',
    formShown: false,
    formLabel: '',
  }),
  computed: {
    ...mapState('applianceRule', { rules: 'list', loading: 'loading' }),
    headers() {
      return [
        { text: 'Прибор', value: 'dishName' },
        { text: 'К категориям', value: 'categories', sortable: false },
        { text: 'Кладём', value: 'quantity' },
        { text: 'Максимум', value: 'maxQuantity' },
        { text: 'Включено', value: 'isEnabled' },
        {
          text: 'Действия', value: 'actions', align: 'center', sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Правила приборов'
    this.fetchRules()
    this.fetchOptions()
  },
  methods: {
    ...mapActions('applianceRule', { fetchRules: 'fetchList', deleteRule: 'delete' }),
    ...mapActions('applianceRule/form', ['fetchOptions', 'fetchById', 'resetForm', 'create', 'update']),
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    add() {
      this.resetForm()
      this.formLabel = 'Новое правило приборов'
      this.formShown = true
    },
    async edit(id) {
      await this.fetchById(id)
      this.formLabel = 'Правило приборов'
      this.formShown = true
    },
    closeForm() {
      this.formShown = false
    },
    async saveRule() {
      const { id } = this.$store.state.applianceRule.form

      await (id ? this.update() : this.create())

      this.formShown = false
      this.fetchRules()
    },
    deletePopupShow(id, name) {
      this.deleteLabel = `Правило для «${name || 'прибора'}» будет удалено.`
      this.$refs.deletePopup.open(id)
    },
    removeRule(id) {
      return this.deleteRule(id)
    },
  },
}
</script>
